import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from '@/lang/i18n/zh.json'
import en from '@/lang/i18n/en.json'
import ja from '@/lang/i18n/ja.json'

Vue.use(VueI18n)

const locale = 'zh'

const messages = {
  zh: zh,
  en: en,
  ja: ja
}

const options = {
  locale,
  messages
}

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  const { getMissingHandler } = require('@/lang/collectMissingKeys')
  options.missing = getMissingHandler()
}

const i18n = new VueI18n(options)

export default i18n
